module.exports = __webpack_public_path__ + "img/no_person.45965a25.jpg";